import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/EmiForm.css";

function EmiForm() {
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [form, setForm] = useState({
    name: "", email: "", phone: "", dob: "", pan: "", aadhaar: "",
    bank_id: "", bank_name: "", account_type: "",
    account_no: "", confirm_account: "", ifsc: "", amount: ""
  });

  useEffect(() => {
    fetch("https://kolibusiness.com/backend/get-bank-list.php")
      .then(res => res.json())
      .then(data => {
        if (data?.StatusCode === "NP000") {
          setBanks(data.data.banks);
        } else {
          alert("Failed to fetch bank list.");
        }
      })
      .catch(err => {
        console.error("Bank list error", err);
        alert("Error fetching banks.");
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (form.account_no !== form.confirm_account) {
    alert("Bank account numbers do not match.");
    return;
  }

  if (!/^\d{12}$/.test(form.aadhaar)) {
    alert("Please enter a valid 12-digit Aadhaar number.");
    return;
  }

  const { confirm_account, ...toSave } = form;
  localStorage.setItem("emi_form", JSON.stringify(toSave));

  try {
    const response = await fetch("https://kolibusiness.com/backend/save-emi-form.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    const text = await response.text();

    try {
      const result = JSON.parse(text);
      if (result.success) {
        localStorage.setItem("emi_id", result.emi_id);
        localStorage.setItem("emi_form", JSON.stringify(form));
        navigate("/emi-documents");
      } else {
        alert("❌ Failed to save EMI form: " + result.message);
      }
    } catch (parseErr) {
      alert("❌ Server sent invalid response:\n" + text);
    }

  } catch (err) {
    alert("❌ Network error occurred while saving EMI form.");
    console.error(err);
  }
};

  return (
    <div className="emi-form-wrapper">
      <form onSubmit={handleSubmit} className="emi-form-box">
        <h2>📝 Setup Your EMI Mandate</h2>
        <label>Name</label>
        <input name="name" required placeholder="Full Name" onChange={handleChange} />
        <label>Email</label>
        <input name="email" type="email" required placeholder="Email" onChange={handleChange} />
        <label>Phone Number</label>
        <input name="phone" required placeholder="Phone Number" onChange={handleChange} />
        <label>PAN Number</label>
        <input name="pan" required placeholder="PAN Number" onChange={handleChange} />
        <label>Aadhaar Number</label>
        <input name="aadhaar" required placeholder="Aadhaar Number (12 digits)" onChange={handleChange} />
        <label>Bank Name</label>
        <select name="bank_id" required onChange={e => {
          const selected = banks.find(b => b.id === parseInt(e.target.value));
          setForm(prev => ({
            ...prev,
            bank_id: selected?.id || "",
            bank_name: selected?.name || ""
          }));
        }}>
          <option value="">-- Select Bank --</option>
          {banks.map(bank => (
            <option key={bank.id} value={bank.id}>{bank.name}</option>
          ))}
        </select>
          <label>Account Type</label>
        <select name="account_type" value={form.account_type} onChange={handleChange}>
          <option value="">-- Select Account Type --</option>
          <option value="Savings">Savings</option>
          <option value="Current">Current</option>
          <option value="OTHER">Other</option>
        </select>
          <label>Account Number</label>
        <input name="account_no" required placeholder="Account Number" onChange={handleChange} />
        <label>Confirm Account Number</label>
        <input name="confirm_account" required placeholder="Confirm Account Number" onChange={handleChange} />
        <label>IFSC Code</label>
        <input name="ifsc" required placeholder="IFSC Code" onChange={handleChange} />
        <label>Amount</label>
        <input name="amount" required placeholder="EMI Amount (₹)" onChange={handleChange} />

        <button type="submit">Continue to Document Upload</button>
      </form>
    </div>
  );
}

export default EmiForm;
